import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { RoutesConstants } from '../../../shared/constants';
import { AppTypeEnum } from '../../../shared/enums';
import { NavigatorHelper } from '../../../shared/helpers';
import { MatDialog } from '@angular/material/dialog';
import { InfoDialogComponent } from '../../../shared/dialogs/info-dialog/info-dialog.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-testing-home',
  imports: [MatIconModule, MatButtonModule],
  templateUrl: './testing-home.component.html',
  styleUrl: './testing-home.component.scss'
})
export class TestingHomeComponent {

  constructor(
    private router: Router,
    private dialog: MatDialog,
  ) { }

  public startApp() {
    NavigatorHelper.setAppType(AppTypeEnum.testing);
    this.router.navigate([RoutesConstants.TESTING_START]);
  }

  public openInfo() {
    this.dialog.open(InfoDialogComponent, {
      data: { appType: AppTypeEnum.testing },
      panelClass: 'info-dialog',
    });
  }

}
